import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateMoneyPage as UpdateMoneyPageMutation,
    UpdateMoneyPageVariables,
    UrlUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_MONEY_PAGE from '../mutations/update-money-page.graphql';

export const useUpdateMoneyPage = (): {
    updateMoneyPage: (input: UrlUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateMoneyPage, {loading, error}] = useMutation<
        UpdateMoneyPageMutation,
        UpdateMoneyPageVariables
    >(UPDATE_MONEY_PAGE);

    return {
        updateMoneyPage: (input: UrlUpdateInput) => updateMoneyPage({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
